export default __webpack_public_path__ + "static/media/XUSOM-circle-logo-no-background-300x300.00871a6f.png";